import { Text } from '@infura/packages.ui/Text'

import { CreditThroughputSkeleton } from 'components/dashboard/analytics-overview/CreditThroughput/CreditThroughputSkeleton'

import { useThroughput } from 'hooks/useThroughput'
import { useUKSProjects } from 'hooks/useUKSProjects'
import { useUKSServicePlan } from 'hooks/useUKSServicePlan'

const transformCreditUnitsPerSecond = (creditUnitsPerSecond: number) => {
  return `${creditUnitsPerSecond / 1000}k`
}

export const CreditThroughputValues = () => {
  const { isLoading: isServicePlanLoading, servicePlan } = useUKSServicePlan()
  const { data: projects } = useUKSProjects()
  const keys = Object.keys(projects?.result?.projects || {})
  const { error, isLoading, throughputData } = useThroughput({ keys, refreshInterval: 10000 })

  if (isLoading || isServicePlanLoading) {
    return <CreditThroughputSkeleton />
  }

  if (error) {
    return <Text className='text-sm'>There was an error loading the credit throughput data</Text>
  }

  return (
    <div className='mb-4 text-gray-600'>
      <Text className='mb-3 text-sm sm:mb-6'>Estimated max from the last 30 days</Text>
      <div className='flex items-end gap-1'>
        <Text className='text-5xl font-bold leading-[46px] text-black'>
          {throughputData.data[0].result?.[0]?.find(res => res.key === 'ur')?.value ?? 0}
        </Text>
        <Text>
          credits/second of {transformCreditUnitsPerSecond(servicePlan?.limits?.creditUnits?.creditUnitsPerSecond ?? 0)}{' '}
          used
        </Text>
      </div>
    </div>
  )
}
